// extracted by mini-css-extract-plugin
module.exports = {"validation":"styles_validation__IkwqM","text":"styles_text__gTBtP","buttonGroup":"styles_buttonGroup__gKdNM"};